export default __webpack_public_path__ + "static/uncuartopollosolopapa-eebafeb7b6e48b13ff8e93b428a7c7bc.jpg";